/* eslint-disable react/jsx-props-no-spreading */
import React, {ReactElement} from 'react';
import {Cookies} from 'react-cookie';
import SiteContextProvider, {SiteContextProviderProps} from './RootProvider/SiteContextProvider';
import {cookieDomain, DEFAULT_LOCALE, LANGUAGE_COOKIE_NAME, hasSecureCookie} from './constants';
import {isValidLocale} from './localeUtils/isValidLocale';
import getFlags from './flagGetter';
import {initMixpanel} from './analytics/tracking/tracking';
import {injectGlobalStyles} from './styles/js/global.main';

export interface WrapPageElementProps {
  element: ReactElement;
  props: Partial<SiteContextProviderProps>;
}

// Pass all props (hence the ...props) to the layout component so it has access to things like pageContext or location
const wrapPageElement = ({element, props}: WrapPageElementProps): ReactElement => {
  const FLAGS = getFlags();
  const {pageContext = {locale: undefined}} = props;
  let {locale: displayLang = DEFAULT_LOCALE} = pageContext;
  initMixpanel();
  injectGlobalStyles();

  // override page locale if user has language set in cookies
  if (FLAGS.CONFIGURABLE_LANGUAGE) {
    const cookies = new Cookies();
    const lang = cookies.get(LANGUAGE_COOKIE_NAME);

    if (isValidLocale(lang)) {
      displayLang = lang;
    }

    if (!lang && isValidLocale(displayLang)) {
      cookies.set(LANGUAGE_COOKIE_NAME, displayLang, {
        path: '/',
        domain: cookieDomain,
        secure: hasSecureCookie,
      });
    }
  }

  return (
    <SiteContextProvider {...(props as SiteContextProviderProps)} language={displayLang}>
      {element}
    </SiteContextProvider>
  );
};

export default wrapPageElement;
